import React from 'react';
import { Bot } from 'lucide-react';
import styles from './EmptyState.module.scss';

const EmptyState = () => {
  return (
    <div className={styles.emptyState}>
      <Bot size={48} className={styles.emptyStateIcon} />
      <p>Start a conversation</p>
      <p>Ask a question or drag and drop files to upload</p>
    </div>
  );
};

export default EmptyState;